import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/service/apiServices';
import Swal from 'sweetalert2';
import { Global } from '../../global';
import { AuthService } from '../../service/auth/auth.service';
import * as moment from 'moment';

@Component({
  selector: 'app-emissao-senhas',
  templateUrl: './emissao-senhas.component.html',
  styleUrls: ['./emissao-senhas.component.css']
})
export class EmissaoSenhasComponent implements OnInit {

  listServicos: any = [];
  listPrioridades: any = [];
  loading: boolean = false;
  ultimaSenhaEmitida: any = null;

  // Informações fixas da unidade
  nomeUnidade: string = "";
  nomeMunicipio: string = "";

  estabelecimento_id: number = 0;
  constructor(
    public service: ApiService,
    public global: Global,
    private authService: AuthService
  ) { }

  ngOnInit() {
    this.authService.currentPresenca.subscribe((res) => {
      if (res) {
        this.estabelecimento_id = res.estabelecimento_id;
        this.carregarDados();
      }
    })
  }

  carregarDados() {
    this.loading = true;
    Swal.fire({
      title: 'Favor aguarde',
      allowOutsideClick: false,
      allowEscapeKey: false
    });
    Swal.showLoading();

    // Carregar serviços e prioridades em paralelo
    Promise.all([
      this.service.Get(`ServicoPainelSenha?ativo=true&estabelecimento_id=${this.estabelecimento_id}`),
      this.service.Get('PrioridadeSenha?ativo=true')
    ]).then(([servicos, prioridades]) => {
      this.listServicos = servicos || [];
      this.listPrioridades = prioridades || [];
      Swal.close();
      this.loading = false;
    }).catch(res => {
      this.listServicos = [];
      this.listPrioridades = [];
      Swal.close();
      this.loading = false;

      if (res && (res.status == 401 || (res.error && res.error.status == 401))) {
        this.authService.logoutUser();
        return;
      }

      if (res && res.error && res.error.erros && res.error.erros[0]) {
        Swal.fire('Erro', `${res.error.erros[0].messagem}`, 'error');
      } else {
        Swal.fire('Erro', 'Ocorreu um erro ao carregar os dados', 'error');
      }
    });
  }

  emitirSenha(servicoId: number, prioridadeId: number, servicoNome: string, prioridadeNome: string) {
    this.confirmarEmissao(servicoId, prioridadeId);
  }

  confirmarEmissao(servicoId: number, prioridadeId: number) {
    this.loading = true;
    Swal.fire({
      title: 'Emitindo senha...',
      allowOutsideClick: false,
      allowEscapeKey: false
    });
    Swal.showLoading();

    const obj = {
      "servico_painel_senha_id": servicoId,
      "prioridade_senha_id": prioridadeId
    };

    this.service.Post('ChamadaSenha/Senha', obj).then(res => {
      Swal.close();
      this.loading = false;

      // Armazenar dados da senha emitida
      this.ultimaSenhaEmitida = res;

      // Exibir a senha emitida com botão de imprimir
      const senha = (res as any).senha || 'N/A';
      this.imprimirSenha();
    }).catch(res => {
      Swal.close();
      this.loading = false;

      if (res && (res.status == 401 || (res.error && res.error.status == 401))) {
        this.authService.logoutUser();
        return;
      }

      if (res && res.error && res.error.erros && res.error.erros[0]) {
        Swal.fire({
          icon: 'error',
          title: 'Erro ao Emitir Senha',
          text: res.error.erros[0].messagem
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: 'Ocorreu um erro ao emitir a senha'
        });
      }
    });
  }

  recarregar() {
    this.carregarDados();
  }

  imprimirSenha() {
    if (!this.ultimaSenhaEmitida) {
      Swal.fire('Erro', 'Nenhuma senha para imprimir', 'error');
      return;
    }

    const dados = this.ultimaSenhaEmitida as any;

    // Formatar data e hora (usando UTC para manter a hora original sem conversão de timezone)
    const dataChegada = dados.chegada_em ? moment.utc(dados.chegada_em).format('DD/MM/YYYY') : '';
    const horaChegada = dados.chegada_em ? moment.utc(dados.chegada_em).format('HH:mm') : '';
    this.nomeUnidade = dados.cabecalho_estabelecimento_nome;
    this.nomeMunicipio = dados.cabecalho_cidade_nome;
    
    // Criar conteúdo HTML para impressão
    const printContent = `
      <!DOCTYPE html>
      <html>
      <head>
        <meta charset="UTF-8">
        <title>Senha - ${dados.senha}</title>
        <style>
          @page {
            size: 80mm auto;
            margin: 2px;
          }

          * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
          }

          body {
            font-family: Arial, sans-serif;
            font-size: 9pt;
            padding: 2px;
            max-width: 80mm;
            margin: 0 auto;
            line-height: 1;
          }

          .header {
            text-align: center;
            margin-bottom: 2px;
            border-bottom: 1px solid #000;
            padding-bottom: 2px;
          }

          .header h1 {
            margin: 0;
            font-size: 9pt;
            font-weight: bold;
          }

          .header p {
            margin: 0;
            font-size: 7pt;
          }

          .tipo-senha {
            text-align: center;
            margin: 2px 0;
            padding: 2px;
            background-color: ${dados.prioridade_senha_cor || '#000'};
            color: ${this.getContrastColor(dados.prioridade_senha_cor || '#000')};
            border-radius: 3px;
            font-weight: bold;
            font-size: 9pt;
          }

          .numero-senha {
            text-align: center;
            font-size: 20pt;
            font-weight: bold;
            margin: 2px 0;
            letter-spacing: 2px;
          }

          .servico {
            text-align: center;
            font-size: 8pt;
            font-weight: bold;
            margin: 2px 0;
            padding: 2px;
            border: 1px solid #000;
            border-radius: 3px;
          }

          .logo-superior img, .logo-inferior img {
            max-height: 48px;
            object-fit: contain;
            display: block;
            margin: 0 auto 2px auto;
          }

          .info {
            text-align: center;
            margin: 2px 0;
            font-size: 7pt;
          }

          .footer {
            text-align: center;
            margin-top: 2px;
            padding-top: 2px;
            border-top: 1px dashed #000;
            font-size: 6pt;
          }

          @media print {
            body {
              padding: 2mm;
            }
          }
        </style>
      </head>
      <body>
        ${dados.logo_impresso_superior_url ? `<div class="logo-superior"><img src="${dados.logo_impresso_superior_url}" alt="logo superior"></div>` : ''}
        <div class="header">
          <h1>${this.nomeUnidade}</h1>
          <p>${this.nomeMunicipio}</p>
        </div>

        <div class="tipo-senha">
          ${dados.prioridade_senha_nome || 'NORMAL'}
        </div>

        <div class="numero-senha">
          ${dados.senha || 'N/A'}
        </div>

        <div class="servico">
          ${dados.servico_painel_senha_nome || 'ATENDIMENTO'}
        </div>

        <div class="info">
          <strong>Data:</strong> ${dataChegada}
        </div>

        <div class="info">
          <strong>Hora de chegada:</strong> ${horaChegada} (Horário local)
        </div>

        ${dados.logo_impresso_inferior_url ? `<div class="logo-inferior"><img src="${dados.logo_impresso_inferior_url}" alt="logo inferior"></div>` : ''}
        <div class="footer">
          <p>Aguarde ser chamado</p>
        </div>
      </body>
      </html>
    `;

    // Criar iframe oculto para impressão
    const iframe = document.createElement('iframe');
    iframe.style.position = 'absolute';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = 'none';
    
    document.body.appendChild(iframe);
    
    if (iframe.contentWindow) {
      const iframeDoc = iframe.contentWindow.document;
      iframeDoc.open();
      iframeDoc.write(printContent);
      iframeDoc.close();
      
      // Aguardar o carregamento e chamar a impressão com a impressora padrão
      iframe.onload = () => {
        setTimeout(() => {
          if (iframe.contentWindow) {
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
          }
          
          // Remover o iframe após a impressão
          setTimeout(() => {
            document.body.removeChild(iframe);
          }, 100);
        }, 250);
      };
    }
  }

  formatarData(dataISO: string): string {
    const data = new Date(dataISO);
    const dia = String(data.getDate()).padStart(2, '0');
    const mes = String(data.getMonth() + 1).padStart(2, '0');
    const ano = data.getFullYear();
    return `${dia}/${mes}/${ano}`;
  }

  // Função para calcular cor de contraste (branco ou preto) baseado na cor de fundo
  getContrastColor(hexColor: string): string {
    if (!hexColor) return '#000000';

    // Remove o # se existir
    const color = hexColor.replace('#', '');

    // Converte para RGB
    const r = parseInt(color.substr(0, 2), 16);
    const g = parseInt(color.substr(2, 2), 16);
    const b = parseInt(color.substr(4, 2), 16);

    // Calcula a luminosidade
    const luminosity = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

    // Retorna preto para cores claras e branco para cores escuras
    return luminosity > 0.5 ? '#000000' : '#FFFFFF';
  }
}
